import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
import {
  lerSessao,
  salvarSessao,
  limparSessao,
  type SessionUser,
} from '@/utils/bootstrapAdmin'

interface AuthContextValue {
  user: SessionUser | null
  isAuthenticated: boolean
  isAdmin: boolean
  loading: boolean
  login: (user: SessionUser) => void
  logout: () => void
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<SessionUser | null>(() => lerSessao())
  const [loading, setLoading] = useState<boolean>(false)

  // Sincroniza sessão entre abas
  useEffect(() => {
    const onStorage = () => setUser(lerSessao())
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const login = useCallback((u: SessionUser) => {
    salvarSessao(u)
    setUser(u)
  }, [])

  const logout = useCallback(() => {
    limparSessao()
    setUser(null)
  }, [])

  const value: AuthContextValue = {
    user,
    isAuthenticated: !!user,
    isAdmin: user?.userRole === 'ADMIN',
    loading,
    login,
    logout,
  }

  return React.createElement(AuthContext.Provider, { value }, children)
}

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuth deve ser usado dentro de <AuthProvider>')
  }
  return ctx
}
